import React from "react";
import { Link } from "react-router-dom";
import { PageHeadingContainer } from "./PageHeading.style";

/**
 * tone="site": the new site palette (light blue tint with blue shapes, same as the Home and About
 * pages) instead of the original cream with orange shapes.
 */
const PageHeading = ({ title, breadcrumbs = [], tone }) => {
    return (
        <PageHeadingContainer>
            <div className={`pageheading_section${tone === "site" ? " pageheading_section--site" : ""}`}>
                <div className="mygrid-container">
                    <div className="mygrid-row">
                        <div className="mygrid-col-md-12">
                            {/* Breadcrumbs */}
                            {breadcrumbs.length > 0 && (
                                <nav className="breadcrumb_page_heading">
                                    {breadcrumbs.map((crumb, index) => (
                                        <span key={index}>
                                            {crumb.path ? (
                                                <Link to={crumb.path} className="hover:underline">
                                                    {crumb.label}
                                                </Link>
                                            ) : (
                                                <span>{crumb.label}</span>
                                            )}
                                            {index < breadcrumbs.length - 1 && " > "}
                                        </span>
                                    ))}
                                </nav>
                            )}
                            {/* Page Title */}
                            <h1 className="page_heading_h1">{title}</h1>
                        </div>
                    </div>
                </div>
            </div>
        </PageHeadingContainer>
    );
};

export default PageHeading;
